/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Modified_LabelInputs */

const en_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified:`)
};

const fr_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifie :`)
};

const de_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert:`)
};

const it_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificato:`)
};

const ru_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменено:`)
};

const es_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificado:`)
};

const zh_cn2_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改的：`)
};

const ja_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更:`)
};

const hi_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संशोधित:`)
};

const pt_pt2_explorer_thumbnail_modified_label = /** @type {(inputs: Explorer_Thumbnail_Modified_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificado:`)
};

/**
* | output |
* | --- |
* | "Modified:" |
*
* @param {Explorer_Thumbnail_Modified_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_modified_label = /** @type {((inputs?: Explorer_Thumbnail_Modified_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Modified_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_modified_label(inputs)
	if (locale === "de") return de_explorer_thumbnail_modified_label(inputs)
	if (locale === "it") return it_explorer_thumbnail_modified_label(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_modified_label(inputs)
	if (locale === "es") return es_explorer_thumbnail_modified_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_modified_label(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_modified_label(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_modified_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_modified_label(inputs)
	return en_explorer_thumbnail_modified_label(inputs)
});